var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMwLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 350.1 61.9",
    style: {
      enableBackground: "new 0 0 350.1 61.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B563FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.2,3.3h17.4l8.8,13.5l8.7-13.5h16.2v25.3H42.1v-17l0,0L31.3,28.7h-8.6L11.9,11.6l0,0v17.1H2.2V3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.2,19.8V9.6h10.3v7.3c0,3.5,1.5,5,7.3,5c5.3,0,9.2-1.9,9.2-6.2v-6h10.3v19H83c0-1.3,0.1-3.7,0.1-5.9H83 c-1.3,4.2-5.8,6.3-13.8,6.3C60.3,29.1,56.2,25.5,56.2,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.1,1.7h10.3v26.9H96.1V1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.4,21.6v-5.7h-4.5V9.6h3.8c1.4,0,2-0.5,2.3-1.8l0.3-2.5h8.4v4.3h13.7v6.2h-13.7v4.8c0,1.8,1,2.4,7.5,2.4 c2.5,0,4.8-0.2,6-0.3v5.8c-1.2,0.2-4.3,0.5-8.5,0.5C115.1,29.1,112.4,25.5,112.4,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,2.1h10.3v5.5h-10.3V2.1z M139.2,9.6h10.3v19h-10.3V9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.4,9.6h12.9l8.5,11.3h0.1l8.5-11.3h11.3l-14.6,19h-12L151.4,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.2,20.4h-24.7c0.5,2.1,2.6,3.4,8.3,3.4c5.3,0,7.2-0.9,7.5-2h8.9c-0.3,4-4.9,7.3-16.7,7.3 c-14.4,0-18.5-5-18.5-9.8c0-6.3,6.9-10.2,18.2-10.2c11.4,0,17,3.6,17,9.7V20.4z M219.3,16.9c0-1.5-2-2.8-7.7-2.8 c-4.8,0-7.2,1.1-8,3h15.6L219.3,16.9L219.3,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M230.3,9.6h10.3l-0.1,5.5h0.1c1.3-3.1,4.4-6,11-6c8.7,0,11.4,3.8,11.4,9.3c0,0.9-0.1,2.2-0.2,3.4h-9 c0-0.4,0.1-0.9,0.1-1.6c0-2.2-1.5-3.9-5.8-3.9c-5.1,0-7.5,2.6-7.5,6.3v6h-10.3L230.3,9.6L230.3,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.1,22.3h8.9c0.1,1,1,2.1,7,2.1c5.8,0,7.2-0.8,7.2-1.7c0-0.5-0.3-0.9-1.9-1c-1.6-0.2-4.8-0.2-8.3-0.3 c-4.8-0.2-8.2-0.5-10.1-1.3s-2.8-2.3-2.8-3.8c0-4.2,5.9-7,16.3-7c13.9,0,15.7,3.7,15.7,6.9h-8.9c0-1.2-1.1-2.2-6.3-2.2 c-4.8,0-6.7,0.8-6.7,1.8c0,0.6,0.5,1,2.2,1.2s4.7,0.2,8.1,0.3c3.2,0.1,7.2,0.3,9.5,1c2.5,0.8,3.4,2.3,3.4,4.2 c0,3.1-2.8,6.8-17.2,6.8C266.5,29.2,265.1,24.9,265.1,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.5,23.2c0-2.7,2.2-5.2,9.1-5.2h15v-0.4c0-1.8-1.9-3-7.8-3c-4.9,0-6.4,1-6.4,2c0,0,0,0.2,0,0.3h-9.1 c-0.1-0.4-0.1-0.8-0.1-1c0-3.8,4.7-6.7,16.3-6.7c11.9,0,17.4,3.5,17.4,8.7v10.8h-10.3c0.1-1.5,0.2-2.8,0.2-4l0,0 c-1.1,2.7-4.9,4.5-12.3,4.5C303,29.2,300.5,25.9,300.5,23.2z M324.7,21.6v-0.2h-10.9c-2.6,0-3.8,0.3-3.8,1.2c0,1,1.5,1.7,5.9,1.7 C321.6,24.4,324.6,22.8,324.7,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M337.7,1.7H348v26.9h-10.3V1.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.2,32.1h9.7v18.7l0,0l10.8-18.7h8.6L42,50.8l0,0V32.1h11.2V59H37.1l-8.7-13.5L19.5,59H2.2V32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.3,53.5c0-2.7,2.3-5.2,9.8-5.2h16.2v-0.4c0-1.8-2-3-8.4-3c-5.3,0-6.9,1-6.9,2c0,0,0,0.2,0,0.3h-9.8 c-0.1-0.4-0.1-0.8-0.1-1c0-3.8,5.1-6.7,17.5-6.7c12.8,0,18.8,3.5,18.8,8.7V59H82.3c0.1-1.5,0.2-2.8,0.2-4l0,0 c-1.2,2.7-5.3,4.5-13.2,4.5C58.9,59.5,56.3,56.3,56.3,53.5z M82.3,52v-0.2H70.5c-2.8,0-4.1,0.3-4.1,1.2c0,1,1.6,1.7,6.3,1.7 C78.9,54.8,82.2,53.1,82.3,52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.1,32.1h10.3V59H96.1V32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.4,32.1h10.3v16.4l0,0l13.5-8.4h14l-13.7,8.3L148.1,59h-15.4l-8.2-6.2l-4.8,2.6V59h-10.3 C109.4,59,109.4,32.1,109.4,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.6,50.8h-24.7c0.5,2.1,2.6,3.4,8.3,3.4c5.3,0,7.2-0.9,7.5-2h8.9c-0.3,4-4.9,7.3-16.7,7.3 c-14.4,0-18.5-5-18.5-9.8c0-6.3,6.9-10.2,18.2-10.2c11.4,0,17,3.6,17,9.7V50.8z M172.8,47.2c0-1.5-2-2.8-7.7-2.8 c-4.8,0-7.2,1.1-8,3h15.6L172.8,47.2L172.8,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.8,40h10.3l-0.1,5.5h0.1c1.3-3.1,4.4-6,11-6c8.7,0,11.4,3.8,11.4,9.3c0,0.9-0.1,2.2-0.2,3.4h-9 c0-0.4,0.1-0.9,0.1-1.6c0-2.2-1.5-3.9-5.8-3.9c-5.1,0-7.5,2.6-7.5,6.3v6h-10.3V40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.5,52.7h8.9c0.1,1,1,2.1,7,2.1c5.8,0,7.2-0.8,7.2-1.7c0-0.5-0.3-0.9-1.9-1c-1.6-0.2-4.8-0.2-8.3-0.3 c-4.8-0.2-8.2-0.5-10.1-1.3c-1.9-0.8-2.8-2.3-2.8-3.8c0-4.2,5.9-7,16.3-7c13.9,0,15.7,3.7,15.7,6.9h-8.9c0-1.2-1.1-2.2-6.3-2.2 c-4.8,0-6.7,0.8-6.7,1.8c0,0.6,0.5,1,2.2,1.2s4.7,0.2,8.1,0.3c3.2,0.1,7.2,0.3,9.5,1c2.5,0.8,3.4,2.3,3.4,4.2 c0,3.1-2.8,6.8-17.2,6.8C220,59.5,218.5,55.2,218.5,52.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.3,40h-1.5v-1.4h4.9V40h-1.5v4h-1.9V40z M257.4,42.1L257.4,42.1l1.1-3.6h1.4l1.1,3.6l0,0v-3.5h1.7v5.5 h-2.6l-1-3.2l0,0l-1,3.2h-2.6v-5.5h1.7v3.5H257.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMwLogo);
export default __webpack_public_path__ + "static/media/MW_Logo.674b718df6f8c4644fcca34a7e92303c.svg";
export { ForwardRef as ReactComponent };